import colors from '../colors';
import { fontFamily } from './typography';
export var MuiTooltip = {
    styleOverrides: {
        tooltip: {
            fontFamily: fontFamily,
            backgroundColor: colors.grey[900],
            padding: '8px',
            overflow: 'hidden',
            boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '15px',
        },
        tooltipPlacementTop: {
            marginBottom: '4px !important',
        },
        tooltipPlacementBottom: {
            marginTop: '4px !important',
        },
    },
};
